import script from "./VerticalContainerWrapper.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VerticalContainerWrapper.vue?vue&type=script&lang=js"
export * from "./VerticalContainerWrapper.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VerticalContainerWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-components/render-engine/components/elements/layouts/VerticalContainerWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4cb3c39e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4cb3c39e', __exports__)) {
    api.reload('4cb3c39e', __exports__)
  }
  
}


export default __exports__